import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api, { formatApiError } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=not auth
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get('/auth/me');
      setUser(data.user);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (username, password) => {
    const { data } = await api.post('/auth/login', { username, password });
    if (data.access_token) localStorage.setItem('access_token', data.access_token);
    setUser(data.user);
    return data;
  };

  const register = async (username, password, display_name) => {
    const { data } = await api.post('/auth/register', { username, password, display_name });
    if (data.access_token) localStorage.setItem('access_token', data.access_token);
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('access_token');
    setUser(false);
  };

  const updatePreferences = async (prefs) => {
    await api.put('/user/preferences', prefs);
    setUser(prev => ({ ...prev, ...prefs }));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updatePreferences, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
